// src/theme.js
import { createTheme } from '@mui/material/styles';
import { frostedDialogBackdropSx, frostedDialogPaperSx } from './utils/authBranding';

/** Keep in sync with TV_SHELL_BG in authBranding.js */
const DARK_SHELL_BG = '#070d18';

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

const typography = {
  fontSize: 14,
};

const dialogComponents = {
  MuiDialog: {
    defaultProps: {
      BackdropProps: { sx: frostedDialogBackdropSx },
    },
    styleOverrides: {
      paper: frostedDialogPaperSx,
    },
  },
};

const lightTheme = createTheme({
  breakpoints,
  typography,
  components: dialogComponents,
  palette: {
    mode: 'light',
    primary: {
      main: '#2b6cb0',
    },
    secondary: {
      main: '#334155',
    },
    background: {
      default: '#eef2f7',
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(15, 23, 42, 0.92)',
      secondary: 'rgba(15, 23, 42, 0.58)',
    },
    divider: 'rgba(15, 23, 42, 0.12)',
    action: {
      active: 'rgba(15, 23, 42, 0.7)',
      hover: 'rgba(15, 23, 42, 0.06)',
      selected: 'rgba(15, 23, 42, 0.1)',
      disabled: 'rgba(15, 23, 42, 0.35)',
    },
  },
});

const darkTheme = createTheme({
  breakpoints,
  typography,
  components: dialogComponents,
  palette: {
    mode: 'dark',
    primary: {
      main: '#4d9fff',
    },
    secondary: {
      main: '#b0a0b8',
    },
    background: {
      default: DARK_SHELL_BG,
      paper: '#0c1524',
    },
    text: {
      primary: 'rgba(255, 255, 255, 0.92)',
      secondary: 'rgba(255, 255, 255, 0.55)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    action: {
      active: 'rgba(255, 255, 255, 0.7)',
      hover: 'rgba(255, 255, 255, 0.08)',
      selected: 'rgba(255, 255, 255, 0.12)',
      disabled: 'rgba(255, 255, 255, 0.3)',
    },
  },
});

/**
 * @param {'light' | 'dark'} mode
 * @returns {import('@mui/material/styles').Theme}
 */
export function getTheme(mode) {
  return mode === 'dark' ? darkTheme : lightTheme;
}

export default lightTheme;
